import { MenuActions } from "../../TypesAndConstants/types";
import BrushIcon from "@mui/icons-material/Brush";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import React from "react";

export default function getIconComponent(icon: MenuActions) {
  switch (icon) {
    case "brush":
      return (
        <div className={"listItem"}>
          <BrushIcon />
        </div>
      );
    case "color":
      return (
        <div className={"listItem"}>
          <ColorLensIcon />
        </div>
      );
    case "pen":
      return (
        <div
          className={"listItem"}
          style={{
            backgroundImage: `url(${require("../../../Assets/penButton.png")})`,
            width: "30px",
            height: "30px",
            backgroundSize: "cover"
          }}
        />
      );
    case "shape":
      return (
        <div
          className={"listItem"}
          style={{
            backgroundImage: `url(${require("../../../Assets/shapeButton.png")})`,
            width: "30px",
            height: "30px",
            backgroundSize: "cover"
          }}
        />
      );
    case "spring":
      return (
        <div
          className={"listItem"}
          style={{
            backgroundImage: `url(${require("../../../Assets/spring.png")})`,
            width: "30px",
            height: "30px",
            backgroundSize: "cover"
          }}
        />
      );
    case "growshrink":
      return (
        <div
          className={"listItem"}
          style={{
            backgroundImage: `url(${require("../../../Assets/growShrinkButton.png")})`,
            width: "30px",
            height: "30px",
            backgroundSize: "cover"
          }}
        />
      );
    case "wipe":
      return (
        <div
          className={"listItem"}
          style={{
            backgroundImage: `url(${require("../../../Assets/wipeButton.png")})`,
            width: "30px",
            height: "30px",
            backgroundSize: "cover"
          }}
        />
      );
    default:
      return undefined;
  }
}
